import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'
import { getUserData } from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    
    fetchUserOld(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/user/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getFinancesOverview() {
      const userData = getUserData()
      axios.defaults.headers.common["Authorization"] = "Bearer " + userData.token
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Finance/GetFinancesOverview`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getBankAccountList() {
      const userData = getUserData()
      axios.defaults.headers.common["Authorization"] = "Bearer " + userData.token
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/BankAccount/GetList`, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getFinanceAddOrUdpate(ctx, data) {
      const userData = getUserData()
      axios.defaults.headers.common["Authorization"] = "Bearer " + userData.token
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Finance/AddOrUdpate`, data, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSaleOrders(ctx, queryParams) {
      const userData = getUserData()
      axios.defaults.headers.common["Authorization"] = "Bearer " + userData.token
      const payload = {
        "pagination": {
          "total": 0,
          "current": 0,
          "pageSize": 0
        },
        "search": {
          "accountName": "",
          "accountNumber": "",
          "bankName": "",
          "financeType": "Withdraw"
        },
        "sort": {
          "predicate": "",
          "reverse": true
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Finance/GetFinanceList`, payload)
          .then(response => {
            const {
            q = '',
            perPage = 10,
            page = 1,
            sortBy = '',
            sortDesc = false,
            status,
            plan
          } = queryParams

          const queryLowered = q.toLowerCase()
          var dataFromAPI = response.data.data.data.list

          
          const filteredData = dataFromAPI.filter(
            user =>
              /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
              user
          )

          const sortedData = filteredData.sort(sortCompare(sortBy))
          if (sortDesc) sortedData.reverse()

          resolve({
            data: paginateArray(sortedData, perPage, page),
            totalCount: filteredData.length,
          })})
          .catch(error => reject(error))
      })
    },
    fetchSaleOrdersDeposit(ctx, queryParams) {
      const userData = getUserData()
      axios.defaults.headers.common["Authorization"] = "Bearer " + userData.token
      const payload = {
        "pagination": {
          "total": 0,
          "current": 0,
          "pageSize": 0
        },
        "search": {
          "accountName": "",
          "accountNumber": "",
          "bankName": "",
          "financeType": "Deposit"
        },
        "sort": {
          "predicate": "",
          "reverse": true
        }
      }
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Finance/GetFinanceList`, payload)
          .then(response => {
            const {
            q = '',
            perPage = 10,
            page = 1,
            sortBy = '',
            sortDesc = false,
            status,
            plan
          } = queryParams

          const queryLowered = q.toLowerCase()
          var dataFromAPI = response.data.data.data.list

          
          const filteredData = dataFromAPI.filter(
            user =>
              /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
              user
          )

          const sortedData = filteredData.sort(sortCompare(sortBy))
          if (sortDesc) sortedData.reverse()

          resolve({
            data: paginateArray(sortedData, perPage, page),
            totalCount: filteredData.length,
          })})
          .catch(error => reject(error))
      })
    },
  },
}
